import React, { useState } from 'react'
import { Container, Dialog, Divider, Link } from '@material-ui/core'
import './MvrStyle.scss'
import FlexView from 'react-flexview/lib'
import { SessionContextStore } from '../../../context/SessionContext'
import operatorsApi from '../../../api/operators.api'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import { reportGTM } from '../../Core/Utilities/GTagManger'
import { forEach } from 'lodash'
import StorageService, { StorageKey } from '../../../services/StorageService'
import dayjs from 'dayjs'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'

export const mvrUpdate = async (responseData, offersContext) => {
  let isNewMvrInfo = false
  let relevantViolations = []

  offersContext.loadPlansAfterMvrChange(responseData.is_new_violation)

  if (responseData.is_new_violation || responseData.driving_violations.length > 0) {
    responseData.driving_violations.forEach(violation => {
      let now = dayjs()
      let violationDate = dayjs(violation.violation_date)
      let diff = Math.ceil(now.diff(violationDate, 'month') / 12)
      if (diff <= 3) {
        relevantViolations.push(violation)
      }
    })

    if (relevantViolations.length > 0) {
      reportGTM('', '', { even: 'Updated_price_post_mvr' })
      isNewMvrInfo = true
    }
  }

  StorageService.setItem('IS_NEW_MVR_INFORMATION', isNewMvrInfo)
  return { releventViolationsList: relevantViolations, isNewMvrInfo: isNewMvrInfo }
}

export const MVRMessage = () => {
  const [showPopUp, setShowPopUp] = useState(false)
  const sessionContext = React.useContext(SessionContextStore)
  var insuredUsers = sessionContext.user.userInsuredPersons
  let isNewInfo = sessionContext.user.userInsuredPersons.filter(user => user.isNewMvrInfo == true).length > 0

  const openMvrDetailesPopUp = () => {
    reportGTM('', '', { event: 'read_more_mvr' })
    setShowPopUp(true)
  }

  return (
    <>
      {isNewInfo && (
        <Container style={{ backgroundColor: ' #edeff0' }}>
          <div className="mvr-message">
            <FlexView hAlignContent="center" vAlignContent="center">
              <div className="black text-small">
                <span className="bold">Policy rate has been updated, </span>after a review of third party reports regarding the owner’s
                driving license.
                <br />
                <Link component="button" variant="body2" onClick={() => openMvrDetailesPopUp()}>
                  More details
                </Link>
              </div>
            </FlexView>
          </div>
        </Container>
      )}

      <Dialog
        BackdropProps={{
          style: {
            backgroundColor: 'white',
            opacity: 0.74,
          },
        }}
        fullWidth
        open={showPopUp}
        maxWidth={'xs'}
      >
        <div className="popup-box">
          <div className="text-title textcenter title-popup">Violation(s) found</div>
          <div className="text-body black">
            {insuredUsers.length > 0 &&
              insuredUsers.map(user => (
                <div>
                  {user.insured_person_driving_history.length > 0 &&
                    user.insured_person_driving_history.map(violation => (
                      <>
                        <FlexView className="space-between full-width margin-top-basic margin-bottom-basic" vAlignContent={'center'}>
                          <FlexView vAlignContent={'center'} hAlignContent={'left'}>
                            <div className={`text-secondary `}>{violation.violation_description.replaceAll('_', ' ')}</div>
                          </FlexView>
                          <FlexView vAlignContent={'center'} hAlignContent={'right'}>
                            <div className={`text-small `}>
                              {new Date(violation.violation_date).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                              })}
                            </div>
                          </FlexView>
                        </FlexView>
                        <Divider />
                      </>
                    ))}
                </div>
              ))}
          </div>

          <div className="text-tiny">
            *Please contact our support team at 888-871-2421, or at support@voominsurance.com - if you have any questions or concerns
            associated with this update.
          </div>
          <br />
          <Link component="button" variant="body2" style={{ color: ' #5d00ff' }} onClick={() => setShowPopUp(false)}>
            Close
          </Link>
        </div>
      </Dialog>
    </>
  )
}
